import React from 'react';
import PropTypes from 'prop-types';

export default class Column extends React.Component {
  static propTypes = {
    children: PropTypes.any,
    className: PropTypes.string,
    colspan: PropTypes.number,
    filter: PropTypes.string,
    sorted: PropTypes.bool,
    style: PropTypes.object,
    width: PropTypes.any,
  };

  static defaultProps = {
    colspan: null,
    filter: null,
    sorted: false,
    style: null,
    width: null,
  };

  /* Helper function used by Table to apply filtering logic to array of Rows */
  static applyFilters(columns, originalRowProps) {
    let rowProps = originalRowProps; // Avoid assignment of argument

    columns.forEach((column, index) => {
      // Skip columns without a filter defined
      if (column.props.filter === null) {
        return;
      }

      // Filter by the specified filtering
      const exact = (props) => column.props.filter === props.data[index];
      rowProps = rowProps.filter(exact);
    });

    return rowProps;
  }

  // Helper function used by Table to apply filtering logic to array of Rows
  // (Done in place)
  static applySorting(columns, rowProps) {
    columns.forEach((column, index) => {
      // Skip columns without a filter defined
      if (column.props.sorted === false) {
        return;
      }

      // Compare function based on given data index
      const get = (props) => props.data[index];
      function compare(rowA, rowB) {
        const valA = get(rowA);
        const valB = get(rowB);
        if (valA < valB) {
          return -1;
        } else if (valA === valB) {
          return 0;
        }
        return 1;
      }

      // Sort rowProps in place
      rowProps.sort(compare);
    });
  }

  render() {
    const props = {};

    const {className, colspan, width} = this.props;

    let {style} = this.props;
    if (width !== null) {
      style = {...style, width};
    }
    if (colspan !== null) {
      props.colSpan = colspan;
    }
    if (style !== null) {
      props.style = style;
    }
    if (className !== null) {
      props.className = className;
    }

    return <th {...props}>{this.props.children}</th>;
  }
}
